import angular from 'angular';
import { studioServices } from '../../../studio/services';
import { StudioTrialBannerComponent } from './StudioTrialBanner/studioTrialBanner.component';
import { StudioTrialBannerUpdateComponent } from './StudioTrialBannerUpdate/studioTrialBannerUpdate.component';
export const studioTrialBannerModule = angular
    .module('studioTrialBannerModule', [studioServices])
    .component('studioTrialBanner', StudioTrialBannerComponent)
    .component('studioTrialBannerUpdate', StudioTrialBannerUpdateComponent)
    .name;
